var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 46,
    viewBox: "0 0 116 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9405 36.094V30.787H28.6945V0.896999H20.9475L0.146484 30.787V36.094H22.9605V45H28.6945V36.094H33.9405ZM6.61248 30.787L22.9605 7.241V30.787H6.61248Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8418 22.979C39.8418 36.704 46.6128 45.793 58.0198 45.793C69.3658 45.793 76.1368 36.704 76.1368 22.979C76.1368 9.315 69.0608 0.0429993 58.0198 0.0429993C46.9178 0.0429993 39.8418 9.315 39.8418 22.979ZM45.7588 22.979C45.7588 11.999 50.2728 5.411 58.0198 5.411C65.7668 5.411 70.2198 11.999 70.2198 22.979C70.2198 33.837 65.7668 40.425 58.0198 40.425C50.2728 40.425 45.7588 33.837 45.7588 22.979Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.016 30.787V36.094H109.77V45H104.036V36.094H81.2217V30.787L86.6554 22.979H92.6287L87.6877 30.787H104.036V22.979H109.77V30.787H115.016Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.022 0.897003H115.769V22.979H110.035V7.241L98.6283 22.979H92.9248L108.022 0.897003Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.0249afebc5660641824a57e57c670a05.svg";
export { ForwardRef as ReactComponent };